import { JobRequestStatus } from 'services/kraken-core/translation_maps/translationMaps.service'

export const JOB_REQUEST_STORAGE_PREFIX = 'translation-map:job-request:'

export const JOB_REQUEST_MAX_AGE_MS = 25 * 60 * 1000

export interface StoredJobRequest {
  id: string
  type: string
  related_object_uuid: string
  job: {
    uuid: string
    status: JobRequestStatus
  }
  channel: string
  created_at: string
}

function storageKey(relatedObjectUuid: string): string {
  return `${JOB_REQUEST_STORAGE_PREFIX}${relatedObjectUuid}`
}

export function getStoredJobRequest(relatedObjectUuid: string): StoredJobRequest | null {
  try {
    const raw = localStorage.getItem(storageKey(relatedObjectUuid))
    if (!raw) return null
    return JSON.parse(raw) as StoredJobRequest
  } catch {
    return null
  }
}

export function setStoredJobRequest(jobRequest: StoredJobRequest): void {
  localStorage.setItem(storageKey(jobRequest.related_object_uuid), JSON.stringify(jobRequest))
}

export function removeStoredJobRequest(relatedObjectUuid: string): void {
  localStorage.removeItem(storageKey(relatedObjectUuid))
}

export function isJobRequestExpired(
  jobRequest: Pick<StoredJobRequest, 'created_at'>,
  now: number = Date.now()
): boolean {
  const createdAt = new Date(jobRequest.created_at).getTime()
  if (Number.isNaN(createdAt)) return true
  return now - createdAt > JOB_REQUEST_MAX_AGE_MS
}
